const bannerData = {
    home: {
        blueMain: "Empower ",
        whiteMain: ' Your trades',
        subtitle: "AI Strategies for Tomorow's Investors",
        bannerHeight: '357px',
        bannerAlign: 'flex-start'
    },
    "ai-blog": {
        blueMain: 'AI ',
        whiteMain: 'blog',
        subtitle: null,
        bannerHeight: '272px',
        bannerAlign: 'center'
    },
    "ai-tools": {
        blueMain: 'AI',
        whiteMain: ' tools',
        subtitle: null,
        bannerHeight: '272px',
        bannerAlign: 'center'
    },
    "ai-trader": {
        blueMain: 'AI',
        whiteMain: ' trader',
        subtitle: null,
        bannerHeight: '272px',
        bannerAlign: 'center'
    },
    webinars: {
        blueMain: 'Web',
        whiteMain: 'inars',
        subtitle: null,
        bannerHeight: '272px',
        bannerAlign: 'center'
    }
}
export default bannerData